// extracted by mini-css-extract-plugin
export default {"modal":"cprxJyzM_5ERRGLvsWmp","content":"qN8MuvhGr0B6SV3yFMzz"};